import angular from 'angular';

document.write(require('./view.html').default);
document.write(require('./modal.html').default);
document.write(require('./main.html').default);

import './style.scss';
import { BRAND_NAME } from "../../../core/main/controller/environment";
const OBFUSCATED_PASSWORD = "******"
const LANGUAGE_CODE_TO_NAME = {
    "en": "English",
    "fr": "French"
}

angular.module("merchant.application.page.merchantAdmin.shopConfiguration", [
    "merchant.application.module.merchantAdmin.shopConfiguration"
]).controller("merchant.application.page.merchantAdmin.shopConfiguration.controller", [
    "$rootScope", "$scope", "$controller",
    "merchant.application.main.factory.merchantAdmin",
    "merchant.application.main.factory.authentication",
    function($rootScope, $scope, $controller, merchantAdmin, Authentication) {
        $controller("merchant.application.page.controller", {$scope: $scope});

        /*** constant value ****/
        const consentCheckboxText = "I provide " + BRAND_NAME + " my consent to retrieve product information from my website.";
        $scope.model.brandName = BRAND_NAME
        $scope.model.feedDataTypeOptions = [
            {name: "Fetch Shopify website", value: "SHOPIFY"},
            {name: "Google product feed (.xml file)", value: "GOOGLE_XML"},
            {name: "Google product feed (.csv file)", value: "GOOGLE_CSV"}
        ];
        $scope.model.scheduleOptions = [
            {name: "Daily", value: "EVERY_DAY"},
            {name: "Weekly", value: "EVERY_WEEK"},
            {name: "Monthly", value: "EVERY_MONTH"}
        ];
        $scope.model.processStatusOptions = [
            {name: "Working", value: "PROCESSED_SUCCESS"},
            {name: "Working", value: "PROCESSED_SUCCESS_WITH_ERROR"},
            {name: "Failed", value: "PROCESSED_FAIL"},
            {name: "Pending", value: null}
        ];
        $scope.model.errorId2Messages = [
            {name: "FILE_DOWNLOAD_ERROR", value: "We couldn’t download your product feed. Please confirm the link and try again."},
            {name: "FILE_PARSE_ERROR", value: "We had trouble processing your product feed because it was either empty, or is an unsupported file format."},
            {name: "UNKNOWN_CSV_SEPARATOR", value: "Columns in your feed file should be separated by pipes (|) or tabs (\\t) instead of quotes (\")."},
            {name: "UNTERMINATED_DOUBLE_QUOTE", value: "Ensure there are no double quotes escapes in your columns (for example format content like this: \"clothes\" sweater\" )."},
            {name: "MISSING_ID", value:"Your product feed file is missing the \"ID\" column."},
            {name: "MISSING_PRODUCT_NAME", value:"Your product feed file is missing the \"Title\" column."},
            {name: "MISSING_PRODUCT_PRICE", value:"Your product feed file is missing the \"Price\" column."},
            {name: "MISSING_PRODUCT_LINK", value:"Your product feed file is missing the \"Link\" column."},
            {name: "MISSING_PRODUCT_IMAGE", value:"Some products in your product feed file are missing the \"Image_link\" column."},
            {name: "MISSING_PRODUCT_AVAILABILITY", value:"Your product feed file is missing the \"Availability\" column."},
            {name: "INVALID_PRODUCT_IMAGE_LINK", value:"Image files should have an https link, and can be downloaded without further authentication."},
            {name: "INVALID_SKU", value:"Each product should have a unique SKU. Either some products share an SKU, or some products don't have an SKU. These products have been ignored and not processed into our system."},
        ];
        $scope.model.loaded = false;
        $scope.model.hasError = false;
        $scope.model.errorMessage = "There was an issue with your shop directory listing";
        $scope.model.showProcessFailedMessage = false;
        $scope.model.showProcessSuccessWithErrorMessage = false;
        $scope.model.hasShopData = false;

        var parameters = {};
        parameters.merchantId = Authentication.merchantId();

        /**** Forms & functions *****/
        $scope.model.setupConfigForm = false;
        $scope.model.viewConfigForm = false;
        $scope.model.submitSuccessForm = false;

        $scope.showForm = function(formName) {
            $scope.model.setupConfigForm = false;
            $scope.model.viewConfigForm = false;
            $scope.model.submitSuccessForm = false;
            switch (formName) {
                case 'setupForm': $scope.model.setupConfigForm = true; break;
                case 'viewConfig': $scope.model.viewConfigForm = true; break;
                case 'submitSuccess': $scope.model.submitSuccessForm = true; break;
            }
        }

        $scope.pollingStatus = function() {
            //reset consent field
            $scope.model.agreed = null
            merchantAdmin.readShopList(parameters, function(shopConfigurations) {
                initializePage(shopConfigurations)
            });
        }

        $scope.updateFeedConfiguration = function() {
            const model = $scope.model;
            model.hasError = false;
            model.showProcessFailedMessage = false;
            model.showProcessSuccessWithErrorMessage = false;

            const targetShopConfiguration = model.targetShopConfiguration;
            // serverPassword can be null or undefined
            const isValidServerPassword = targetShopConfiguration.serverPassword && targetShopConfiguration.serverPassword.length > 0 && targetShopConfiguration.serverPassword.trim() !== OBFUSCATED_PASSWORD

            const serverPassword = isValidServerPassword ? targetShopConfiguration.serverPassword : null
            merchantAdmin.updateShopConfiguration(
                {
                    feedType: targetShopConfiguration.feedType,
                    shopUrl: targetShopConfiguration.shopUrl,
                    endpoint: targetShopConfiguration.endpoint,
                    schedule: targetShopConfiguration.schedule,
                    utmSource: targetShopConfiguration.utmSource,
                    utmMedium: targetShopConfiguration.utmMedium,
                    serverUserName: targetShopConfiguration.serverUserName,
                    serverPassword: serverPassword
                },
                {merchantId:Authentication.merchantId(), shopId:targetShopConfiguration.shopId},
                ()=> {
                    $scope.showForm('submitSuccess');
                    setTimeout(function () {
                        $scope.pollingStatus();
                    }, 5000);
                },
                ()=> {
                    $scope.model.hasError = true;
                })
        }

        $scope.confirmDeleteConfiguration = function() {
            $scope.model.modulesIncludedInModal = ["merchant-admin-shop-configuration-modal-page.html"];
            $scope.model.isModalVisible = true;
        }

        $scope.viewErrorsModal = function() {
            $scope.model.modulesIncludedInModal = ["merchant-admin-shop-configuration-modal-view-error-page.html"];
            $scope.model.isModalVisible = true;
        }

        $scope.doDeleteConfiguration = function() {
            const targetShopConfiguration = $scope.model.targetShopConfiguration;
            merchantAdmin.updateShopConfiguration(
                {
                    feedType: null,
                    endpoint: null,
                    schedule: null,
                    utmParameters: null,
                    shopUrl: targetShopConfiguration.shopUrl
                },
                {merchantId:Authentication.merchantId(), shopId:targetShopConfiguration.shopId},
                ()=> {
                    document.location.reload();
                },
                ()=> {
                    $scope.model.isModalVisible = false;
                    $scope.model.hasError = true;
                })

        }.bind(this)

        $scope.showSetupForm = function() {
            if ($scope.model.targetShopConfiguration.serverUserName) {
                $scope.model.targetShopConfiguration.serverPassword = OBFUSCATED_PASSWORD
            }
            $scope.showForm('setupForm');
        }

        $scope.submitDisabled = function(angularForm) {
            const targetShopConfiguration = $scope.model.targetShopConfiguration;
            return  !angularForm.$valid || !targetShopConfiguration ||
                !targetShopConfiguration.feedType || !targetShopConfiguration.schedule
        }

        $scope.showViewConfigForm = function() {
            const model = $scope.model;
            const targetShopConfiguration = model.targetShopConfiguration;
            model.configForm = {}
            model.configForm.shopName = $scope.getShopNameWithCountryCode(targetShopConfiguration)
            model.configForm.processStatusText = findNameByValue(model.processStatusOptions,targetShopConfiguration.processStatus)
            model.configForm.feedTypeText = findNameByValue(model.feedDataTypeOptions,targetShopConfiguration.feedType)
            model.configForm.linkToShow = targetShopConfiguration.feedType === 'SHOPIFY' ? targetShopConfiguration.shopUrl : targetShopConfiguration.endpoint;
            model.configForm.lastUpdated = targetShopConfiguration.lastUpdated;
            $scope.showForm('viewConfig');
        }

        $scope.showProcessFailedForm = function() {
            const model = $scope.model;
            model.showProcessFailedMessage = true;
            model.processErrorTitle = 'There was an issue fetching your feed'
            if (model.targetShopConfiguration.feedType === 'SHOPIFY' ) {
                model.processErrorMessage  = 'Website does not use Shopify. Please use the product feed option instead.';
            } else {
                if (model.targetShopConfiguration.errorCodes.includes("FILE_PARSE_ERROR")) {
                    model.processErrorTitle = 'There was an issue uploading your products'
                    model.processErrorMessage = $scope.findErrorMessageByCode("FILE_PARSE_ERROR")
                } else {
                    // FILE_DOWNLOAD_ERROR
                    model.processErrorMessage = 'Please confirm link and try again.';
                }
            }
            $scope.showSetupForm();
        }

        $scope.showProcessSuccessWithErrorForm = function() {
            const model = $scope.model;
            model.showProcessSuccessWithErrorMessage = true;
            model.processErrorTitle = 'There was an issue uploading your products'
            model.processErrorMessage  = 'We had trouble processing the content of your product feed.';
            $scope.showSetupForm();
        }

        function findNameByValue(options, value) {
            let name = "N/A";
            options.forEach(function(item) {
                if (item.value === value) {
                    name = item.name;
                }
            })
            return name
        }

        $scope.findErrorMessageByCode = function(code) {
            let value = "unknown issue"
            $scope.model.errorId2Messages.forEach(function(item) {
                if (item.name === code) {
                    value = item.value;
                }
            })
            return value
        }

        const getFirstShopConfigurationByStatus = (shopConfigurations, status) => shopConfigurations.find(shop => shop.processStatus === status);

        function shopConfigurationDisplayNameComparator(shopConfiguration1, shopConfiguration2) {
            const displayName1 = $scope.getShopNameWithCountryCode(shopConfiguration1);
            const displayName2 = $scope.getShopNameWithCountryCode(shopConfiguration2);
            return displayName1.localeCompare(displayName2)
        }

        $scope.getShopNameWithCountryCode = function(shopConfiguration) {
            const currentLocale = new Intl.Locale(shopConfiguration.locale)
            const hasDuplicateRegions = $scope.model.shopConfigurations
                .filter(config => shopConfiguration.shopName === config.shopName && new Intl.Locale(config.locale).region === currentLocale.region)
                .length > 1;
            if (hasDuplicateRegions) {
                return `${currentLocale.region} (${LANGUAGE_CODE_TO_NAME[currentLocale.language]}): ${shopConfiguration.shopName}`
            }
            return `${currentLocale.region}: ${shopConfiguration.shopName}`
        }

        $scope.clearConfigServerPassword = () => $scope.model.targetShopConfiguration.serverPassword = null

        $scope.showAgreeCheckbox = () => {
            const shopConfiguration = $scope.model.targetShopConfiguration;
            return shopConfiguration && shopConfiguration.feedType && shopConfiguration.schedule && (
                shopConfiguration.shopUrl || shopConfiguration.endpoint
            )
        }

        function initializePage(shopConfigurations) {
            $scope.model.loaded = true;
            $scope.model.agreeText = consentCheckboxText
            if (!shopConfigurations || shopConfigurations.length === 0) {
                $scope.model.errorMessage = "You don't seem to have a shop directory profile setup for you business."
                $scope.model.hasShopData = false;
                return;
            }

            const model = $scope.model;
            model.hasShopData = true;
            model.shopConfigurations = shopConfigurations;
            model.shopConfigurations.sort(shopConfigurationDisplayNameComparator)
            model.hasError = false;
            model.targetShopConfiguration = model.shopConfigurations[0]

            // Display successful configuration if one exists
            let shopConfiguration = getFirstShopConfigurationByStatus(model.shopConfigurations, "PROCESSED_SUCCESS");
            if (shopConfiguration) {
                model.targetShopConfiguration = shopConfiguration
                $scope.showViewConfigForm();
                return
            }

            // Display pending information if any stores pending
            shopConfiguration = getFirstShopConfigurationByStatus(model.shopConfigurations, "PENDING");
            if (shopConfiguration) {
                model.targetShopConfiguration = shopConfiguration
                model.submitSuccessForm = true;
                setTimeout(function () {
                    $scope.pollingStatus();
                }, 5000);
                return
            }

            // Display success with error information
            shopConfiguration = getFirstShopConfigurationByStatus(model.shopConfigurations, "PROCESSED_SUCCESS_WITH_ERROR");
            if (shopConfiguration) {
                model.targetShopConfiguration = shopConfiguration
                $scope.showProcessSuccessWithErrorForm();
                return
            }

            // Display processed fail information of most recently updated store
            shopConfiguration = getFirstShopConfigurationByStatus(model.shopConfigurations, "PROCESSED_FAIL");
            if (shopConfiguration) {
                model.targetShopConfiguration = shopConfiguration
                // for feed file download failure, we asked the merchant to check the link. Otherwise we just show the detailed error message like above
                if (shopConfiguration.errorCodes.includes("FILE_DOWNLOAD_ERROR")
                    || shopConfiguration.errorCodes.includes("FILE_PARSE_ERROR")) {
                    $scope.showProcessFailedForm()
                } else {
                    $scope.showProcessSuccessWithErrorForm();
                }
                return
            }

            // If no matching configuration status, the merchant is new, so we show the setup form
            // currently, the only possibility is null
            $scope.showSetupForm();
        }

        /****** init page *****/
        merchantAdmin.readShopList(parameters, function(shopConfigurations) {
            initializePage(shopConfigurations)
        }, function(e) {
            $scope.model.hasError = true;
        });
    }
]);
